import React, { useEffect, useRef, useState } from 'react'
import { Row, Col, Modal, Button, Spin, Tag } from 'antd'
import badge from '../../../assets/images/settings/badge.png'
import benefits from '../../../assets/images/settings/benefits.png'
import block from '../../../assets/images/settings/block.png'
import businessInfo from '../../../assets/images/settings/businessInfo.png'
import changePassword from '../../../assets/images/settings/changePassword.png'
import contact from '../../../assets/images/settings/contact.png'
import createAd from '../../../assets/images/settings/createAd.png'
import deleteAccount from '../../../assets/images/settings/deleteAccount.png'
import dispute from '../../../assets/images/settings/dispute.png'
import editProfile from '../../../assets/images/settings/editProfile.png'
import faq from '../../../assets/images/settings/faq.png'
import notification from '../../../assets/images/settings/notification.png'
import payments from '../../../assets/images/settings/payments.png'
import privacy from '../../../assets/images/settings/privacy.png'
import rate from '../../../assets/images/settings/rate.png'
import terms from '../../../assets/images/settings/terms.png'
import transaction from '../../../assets/images/settings/transaction.png'
import verifyBusiness from '../../../assets/images/settings/verifyBusiness.png'
import { Switch } from 'antd';
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import DynamicForm from '../../../components/FormElements/DynamicForm'
import { ApiCaller, Colors } from '../../../config'
import { FaEye } from 'react-icons/fa'
import * as Yup from 'yup'
import { useMutation } from 'react-query'
import { setError, setMessage } from '../../../store/common/generalSlice'
import { fetchProfileData } from '../../../store/common/settingSlice'
import ContactSupport from './ContactSupport'
import Confirmation from '../../../components/Modal/Confirmation';
import ExpertPasswordConfirmationModal from './ExpertPasswordConfirmationModal'
import DeleteAccount from './DeleteAccount'
import axiosInstance from '../../../config/api'
import { LoadingOutlined } from '@ant-design/icons'
import { logoutByExpert, updateAccessToken, updateLoggedInUser, updateLoginStatus } from '../../../store/common/authSlice'
import useAuthApi from '../../../config/hooks/api/auth/useAuthApi'
import { statusCheck } from '../../../config/utils/StatusCheck'
import { IoStar } from "react-icons/io5";


const form = {
    name: 'Change Password',
    formFields: [
        {
            name: 'oldPassword',
            label: { value: 'Old Password:', classes: '' },
            type: 'password',
            placeholder: '**********',
            width: { md: 24, sm: 24, xs: 24 },
            component: null,
            classes: 'custom-card-boxshadow outline-none h-10 pt-2',
            icon: <FaEye />
        },
        {
            name: 'newPassword',
            label: { value: 'New Password:', classes: '' },
            type: 'password',
            placeholder: '**********',
            width: { md: 24, sm: 24, xs: 24 },
            component: null,
            classes: 'custom-card-boxshadow outline-none h-10 pt-2',
            icon: <FaEye />
        },
        {
            name: 'confirmPassword',
            label: { value: 'Confirm Password:', classes: '' },
            type: 'password',
            placeholder: '**********',
            width: { md: 24, sm: 24, xs: 24 },
            component: null,
            classes: 'custom-card-boxshadow outline-none h-10 pt-2',
            icon: <FaEye />
        },
    ],
    formValidation: {
        oldPassword: Yup.string()
            .required('Password is required')
            .min(8, 'Password should be 8 characters long')
            .max(20, 'Password should not exceed 20 characters'),
        newPassword: Yup.string()
            .required('Password is required')
            .min(8, 'Password should be 8 characters long')
            .max(20, 'Password should not exceed 20 characters'),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
            .required('Confirm Password is required'),
    }
}

const trustPilotLink = process.env.REACT_APP_TRUST_PILOT

const Settings = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const trustPilotRef = useRef();

    const [passwordModal, setPasswordModal] = useState(false);
    const [contactSupportModal, setContactSupportModal] = useState(false);
    const [expertModal, setExpertModal] = useState(false);
    const [passwordConfirmationModal, setPasswordConfirmationModal] = useState(false);
    const [deleteAccountModal, setDeleteAccountModal] = useState(false);
    const [becomeAnExpertLoadingBySocialLogin, setBecomeAnExpertLoadingBySocialLogin] = useState(false);

    const { logout } = useAuthApi()

    const [passwordState, setPasswordState] = useState({
        oldPassword: false,
        newPassword: false,
        confirmPassword: false
    })

    useEffect(() => {
        dispatch(fetchProfileData())
    }, [])

    useEffect(() => {
        // function to load script immediately when the component mount because on mounting of a component -
        // it is not loading the script, on refresh of the component then only it is loading the script.
        const loadTrustpilot = () => {
            if (window?.Trustpilot) {
                window.Trustpilot.loadFromElement(trustPilotRef.current, true);
            } else {
                const script = document.createElement("script");
                script.src = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
                script.async = true;
                script.onload = () => {
                    if (window.Trustpilot) {
                        window.Trustpilot.loadFromElement(trustPilotRef.current, true);
                    }
                };
                document.body.appendChild(script);
            }
        };
        loadTrustpilot();
    }, []);


    const { loggedInUser } = useSelector(state => state?.auth);
    const { profileData } = useSelector(state => state?.setting);
    const settingsData = [
        {
            img: editProfile,
            title: 'Edit Profile',
            type: 'both',
            navigate: '/settings/editProfile'
        },
        {
            img: payments,
            title: 'Manage Payment',
            type: 'both',
            navigate: '/settings/payments'
        },
        {
            img: businessInfo,
            title: 'Business Information',
            type: 'Service Provider',
            navigate: '/settings/businessInfo'
        },
        // {
        //     img: dispute,
        //     title: 'Report a Dispute',
        //     type: 'both',
        //     navigate: ''
        // },
        {
            img: createAd,
            title: 'Create Ad',
            type: 'Service Provider',
            navigate: '/settings/createAd'
        },
        {
            img: verifyBusiness,
            title: 'Verify Business',
            type: 'Service Provider',
            navigate: '/settings/verify'
        },
        {
            img: badge,
            title: 'Badges',
            type: 'Service Provider',
            navigate: '/settings/badges'
        },
        {
            img: transaction,
            title: 'Transaction History',
            type: 'both',
            navigate: '/settings/transactions'
        },
        {
            img: benefits,
            title: 'Benefits',
            type: 'Service Provider',
            navigate: '/settings/BenefitsOfMobrage'
        },
        {
            img: faq,
            title: 'FAQs',
            type: 'both',
            navigate: '/settings/Faqs'
        },
        {
            img: block,
            title: 'Block User',
            type: 'both',
            navigate: '/settings/blockList'
        },
        {
            img: deleteAccount,
            title: 'Delete Account',
            type: 'both',
            navigate: ''
        },
        {
            img: changePassword,
            title: 'Change Password',
            type: 'both',
            navigate: ''
        },
        {
            img: notification,
            title: 'Notification',
            type: 'both',
            navigate: '',
        },
        {
            img: terms,
            title: 'Terms & Conditions',
            type: 'both',
            navigate: ''
        },
        {
            img: contact,
            title: 'Contact Support',
            type: 'both',
            navigate: ''
        },
        {
            img: privacy,
            title: 'Privacy Policy',
            type: 'both',
            navigate: ''
        },
        {
            img: rate,
            title: 'Rate the App',
            type: 'both',
            navigate: ''
        },
    ]

    // for navigating
    const settingItemHandler = (route) => {
        navigate(route)
    }

    const notificationMutation = useMutation(async () => {
        let res = await axiosInstance.patch('/user/notification-toggle', {});
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message))
                dispatch(fetchProfileData())
            },
            onError: (error) => {
                console.log(error)
                return
            }
        }
    )

    // navigation handler
    const onNotificationChange = (checked) => {
        notificationMutation.mutate()
    }

    const operationHandler = (settingItem) => {
        if (settingItem === 'Change Password') {
            setPasswordModal(true)
        }
        else if (settingItem === 'Contact Support') {
            setContactSupportModal(true)
        }
        else if (settingItem === 'Expert CTA') {
            setExpertModal(true)
        }
        else if (settingItem === 'Delete Account') {
            setDeleteAccountModal(true)
        }
        else if (settingItem === 'Terms & Conditions') {
            window.open('https://mobrage.com/terms-and-conditions/', '_blank')
        }
        else if (settingItem === 'Privacy Policy') {
            window.open('https://mobrage.com/privacy-policy/', '_blank')
        }
    }

    const submitForm = () => {
        document.querySelector('form')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    const changePasswordMutation = useMutation(async (payload) => {
        const { oldPassword, newPassword } = payload;
        let res = await ApiCaller.post('/auth/change-password', { oldPassword, newPassword });
        return res
    },
        {
            onSuccess: (res) => {
                dispatch(setMessage(res?.data?.data?.message || 'Password change successfully'));
                setPasswordModal(false);
            },
            onError: (error) => {
                dispatch(setError(error?.response?.data?.error?.message || 'An error occured'));
            }
        }
    )

    const handleSubmit = (data) => {
        changePasswordMutation.mutate(data)
    }

    const expertPasswordHandler = async () => {
        if (loggedInUser?.isSocialLogin) {
            setBecomeAnExpertLoadingBySocialLogin(true)
            let logoutHandler = await logout()
            if (logoutHandler) {
                setBecomeAnExpertLoadingBySocialLogin(false)
                dispatch(logoutByExpert(true))
                dispatch(updateAccessToken(''))
                dispatch(updateLoggedInUser(null))
                dispatch(updateLoginStatus(false))
                setExpertModal(false)
            }
        }
        else {
            setExpertModal(false)
            setPasswordConfirmationModal(true)
        }
    }

    return (
        <div>
            <h2 className='font-semibold text-lg'>Setting</h2>
            <Row className='bg-white my-2 py-5 px-3 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4' justify={'space-between'}>
                {
                    settingsData?.map((settingItem, index) => {
                        if (loggedInUser?.isSocialLogin && settingItem.title === 'Change Password') {
                            return
                        }
                        if (loggedInUser.type == settingItem?.type || settingItem?.type == 'both') {
                            return (
                                <>
                                    <Col className='flex items-center gap-4 bg-gray-200 p-4 flex-wrap rounded-md cursor-pointer mb-5' onClick={() => settingItemHandler(settingItem?.navigate)} key={index}>
                                        {
                                            settingItem?.title == 'Rate the App' ?
                                                <div className="trustpilot-widget h-8 flex items-center justify-center pt-4" data-locale="en-GB" data-template-id="56278e9abfbbba0bdcd568bc" data-businessunit-id="6772b5debb1f9c4d559a8839" data-style-height="52px" data-style-width="100%" ref={trustPilotRef}>
                                                    <a href="https://uk.trustpilot.com/review/mobrage.com" target="_blank" rel="noopener" className='flex items-center gap-1 font-medium'></a>
                                                </div>
                                                :
                                                <div className='flex gap-1 items-center' onClick={() => operationHandler(settingItem?.title)}>
                                                    <img src={settingItem?.img} className='w-7 h-7' />
                                                    <div className='flex items-center justify-between border flex-wrap'>
                                                        <span className='font-medium'>{settingItem?.title}</span>
                                                        {
                                                            (settingItem?.title == 'Verify Business' && profileData?.userDetail?.status !== 3) &&
                                                            <img src={statusCheck(profileData?.userDetail?.status)} className='hidden sm:inline-block w-6 h-6 lg:w-9 lg:h-9 absolute right-[6px]' alt='' />
                                                        }
                                                    </div>
                                                </div>
                                        }

                                        {
                                            settingItem?.title == 'Notification' && (notificationMutation?.isLoading ? <Spin className='ml-0 lg:ml-16' indicator={<LoadingOutlined spin />} size="small" /> :
                                                <Switch size='small' className='ml-0 lg:ml-16' value={profileData?.isNotificationEnabled} onChange={onNotificationChange} />)
                                        }
                                    </Col>
                                    {
                                        (loggedInUser?.type == 'Service User' && settingsData?.length - 1 == index) &&
                                        <Col className='flex items-center justify-center gap-4 flex-wrap rounded-md cursor-pointer mb-5 p-3 bg-[#fab700] text-white text-center border-1 border-gray-500 border-dashed' onClick={() => operationHandler('Expert CTA')}>
                                            <div className=''>Become an Expert</div>
                                        </Col>
                                    }
                                </>
                            )
                        }
                    })
                }
            </Row>

            {
                passwordModal &&
                <Modal
                    open={passwordModal}
                    width={400}
                    footer={false}
                    onCancel={() => setPasswordModal(false)}
                    centered
                    destroyOnClose
                >
                    <Row className='p-5 flex items-center justify-center'>
                        <h2 className='text-lg font-semibold'>Change Password</h2>
                        <Row className='w-full mt-4'>
                            <DynamicForm
                                form={form}
                                onSubmit={handleSubmit}
                            />
                            <Button
                                onClick={submitForm}
                                loading={changePasswordMutation?.isLoading}
                                htmlType='submit'
                                className='w-full h-10 mt-3 rounded-md outline-none border-none'
                                style={{ background: Colors.AppYellow, color: 'white' }}>
                                Submit
                            </Button>
                        </Row>
                    </Row>
                </Modal>
            }

            {
                contactSupportModal &&
                <ContactSupport contactSupportModal={contactSupportModal} setContactSupportModal={setContactSupportModal} />
            }
            {
                expertModal &&
                <Confirmation
                    title={""}
                    open={expertModal}
                    closeable={false}
                    width={280}
                    heading={"Are you sure you want to export?"}
                    isShowSaveButton={true}
                    className={'payment-confirmation-modal'}
                >
                    <Row className='w-full m-0 p-0 gap-0'>
                        <h2 className='text-center font-semibold mx-auto pt-4 pb-2'>Do you want to switch account to Service Provider?</h2>
                        <span className='text-center mb-2 pb-2 text-[#42425B] text-xs px-4'>Switching profile will assign a permanent role of a Service Provider and can not be reverted.</span>
                        <div className='flex w-full action-btns'>
                            <Button loading={becomeAnExpertLoadingBySocialLogin} className='flex-1 rounded-bl-md bg-[#FAB700] text-black py-2 h-auto' onClick={() => expertPasswordHandler()}>Yes</Button>
                            <Button className='flex-1 rounded-br-md bg-[#000000] text-white py-2 h-auto' onClick={() => setExpertModal(false)}>No</Button>
                        </div>
                    </Row>
                </Confirmation>
            }
            {
                passwordConfirmationModal &&
                <ExpertPasswordConfirmationModal passwordConfirmationModal={passwordConfirmationModal} setPasswordConfirmationModal={setPasswordConfirmationModal} />
            }
            {
                deleteAccountModal &&
                <DeleteAccount deleteAccountModal={deleteAccountModal} setDeleteAccountModal={setDeleteAccountModal} />
            }
        </div>
    )
}

export default Settings